<template>
    <!--公告資訊-->
    <v-flex class="xs12 sm12 md12 lg12 newsBg" style="padding:0px 10px;">

            <v-toolbar v-if="isDialog"  dark dense color="tertiary" >
                <v-toolbar-title> 公告資訊 </v-toolbar-title>

                <v-spacer></v-spacer>
                <v-btn title="關閉視窗" icon dark @click.native="closeDialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn>

            </v-toolbar>

                <v-card-text class="newsBg">
                    <p v-html="regNoteNews"></p>
                </v-card-text>





    </v-flex>

</template>

<script>
    export default {
        name: "NewsPage",
        props:{
          isDialog:{
              type:Boolean,
              default:false,

          }
        },
        data() {
            return {
                regNoteNews: ''
            }
        },
        created(){
          this.axios_getRegNoteNews();
        },
        methods:{
            closeDialog(){
              this.$emit('closeDialog');
            },
            axios_getRegNoteNews (){ //公告資訊說明
                this.regNoteNews = '';
                let url = '';
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                url = this.$store.state.AppSetting.backSrvUrl + "regnote/datasearch/primarykeys/"+zone+"/NEWS/ALLCODE";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        for(let i in response.data.resultSet){
                            if(response.data.resultSet[i].regNote!==undefined&&response.data.resultSet[i].regNote!==''){
                                this.regNoteNews+=response.data.resultSet[i].regNote+"<br/>"
                            }
                        }
                    }else{
                        this.regNoteNews = '';
                    }


                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.regNoteNews = '';
                    } catch(err) {
                        this.regNoteNews = '';
                    }
                });


            },
        }
    }
</script>

<style scoped>

    .newsBg{
        background-image: url("../../../assets/images/dialogBg/greenDialog.png");
    }

</style>